import { containEvent, slideDown, slideUp } from './utilities';

const menus = []

function hideMenus() {
  menus.forEach((menu) => {
    menu.hide();
  });
}

function hideMenusExcept(this_menu) {
  menus.forEach((menu) => {
    if (menu !== this_menu) menu.hide();
  });
}

class ActionMenu {
  constructor(el) {
    this.link = el;
    this.menu = document.querySelector(`[data-for="${el.dataset.menu}"]`);
    this.link.addEventListener('click', this.toggle.bind(this));
    menus.push(this);
  }

  place() {
    if (this.menu) {
      const parent = this.link.offsetParent;
      if (parent) {
        this.menu.style.top = `${this.link.offsetTop + 20}px`;
        this.menu.style.left = `${this.link.offsetLeft}px`
      } else {
        const rect = this.link.getBoundingClientRect();
        this.menu.style.top = `${rect.top + 20}px`;
        this.menu.style.left = `${rect.left}px`
      }
    }
  }

  toggle(e) {
    containEvent(e);
    if (this.link.classList.contains('up')) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    hideMenusExcept(this);
    if (this.menu) {
      this.place();
      this.link.classList.add('up');
      this.menu.classList.add('up');
      document.addEventListener("click", this.hide.bind(this));
    }
  }

  hide() {
    document.removeEventListener("click", this.hide.bind(this));
    if (this.menu) {
      this.link.classList.remove('up');
      this.menu.classList.remove('up');
    }
  }

}


function actionMenu(el) {
  return new ActionMenu(el);
}

export default actionMenu;
